import React from "react";
import Modal from 'react-modal';
import ReactPlayer from 'react-player';

// Make sure to bind modal to your appElement for accessibility
Modal.setAppElement('#root');

const VideoPopup = ({
                      isVideoOpen,
                      setIsVideoOpen,
                      videoId = "EW4ZYb3mCZk",
                    }) => {
  const modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      border: 'none',
      background: '#000',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      width: 'auto',
      height: 'auto',
    },
  };

  const handleClose = () => {
    setIsVideoOpen(false);
  };

  // Convert YouTube video ID to full URL
  const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;

  return (
      <Modal
          isOpen={isVideoOpen}
          onRequestClose={handleClose}
          style={modalStyles}
          contentLabel="Video Modal"
      >
        <div className="modal-video-container" style={{ position: 'relative' }}>
          {/* Close Button */}
          <button
              className="modal-video-close"
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: '-10px',
                right: '-10px',
                background: 'rgba(255, 255, 255, 0.9)',
                border: 'none',
                color: '#000',
                fontSize: '24px',
                cursor: 'pointer',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1001,
                fontWeight: 'bold'
              }}
          >
            ×
          </button>

          {/* Video Player */}
          <div style={{
            width: '100%',
            minWidth: '320px',
            maxWidth: '900px',
            aspectRatio: '16/9'
          }}>
            <ReactPlayer
                url={videoUrl}
                playing={isVideoOpen}
                controls={true}
                width="100%"
                height="100%"
                style={{
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}
                config={{
                  youtube: {
                    playerVars: {
                      autoplay: 1,
                      modestbranding: 1,
                      rel: 0
                    }
                  }
                }}
            />
          </div>
        </div>
      </Modal>
  );
};

export default VideoPopup;
